var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-button',{staticClass:"typeform-share buttonTypeForm",attrs:{"href":_vm.url,"data-mode":_vm.type,"link":true,"icon":"comment-outline","target":"_blank","color":_vm.color,"size":_vm.size,"expanded":_vm.expanded}},[_vm._v(_vm._s(_vm.$t('typeform.feedback'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }